import { Skeleton, Stack } from '@mui/material';
import { ContentRecommendation } from '@/components/content/ContentRecommendation';

export enum HEADER_BORDER_PROMOTIONS_SPOTS {
	ONE = 'DPSV2HeaderBorderPromotionsOne',
	TWO = 'DPSV2HeaderBorderPromotionsTwo',
}

const HeaderBorderPromotionOne = () => (
	<ContentRecommendation
		id={HEADER_BORDER_PROMOTIONS_SPOTS.ONE}
		properties={{
			emsName: HEADER_BORDER_PROMOTIONS_SPOTS.ONE,
		}}
		loadingElement={
			<Stack sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
				<Skeleton width={300} height={26} />
			</Stack>
		}
	/>
);

const HeaderBorderPromotionTwo = () => (
	<ContentRecommendation
		id={HEADER_BORDER_PROMOTIONS_SPOTS.TWO}
		properties={{
			emsName: HEADER_BORDER_PROMOTIONS_SPOTS.TWO,
		}}
		loadingElement={
			<Stack sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
				<Skeleton width={200} height={20} />
			</Stack>
		}
	/>
);

export const Promotions: React.FC = () => (
	<Stack direction="column" justifyContent="center">
		<HeaderBorderPromotionOne />
		<HeaderBorderPromotionTwo />
	</Stack>
);
